import { queriesPayers } from "@query";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { Payer } from "@wingspanhq/wingspan-api-sdk";

import { ContextItem } from "../../../../types";

export const getRequirementPayerFromCache = (
  requirement: IRequirementResponse,
  contextItem: ContextItem
): Payer | undefined => {
  return queriesPayers.getPayer.getQueryData({
    payerId: requirement.payerId ?? ""
  });
};
